var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"background"},[_c('v-progress-circular',{staticClass:"progress",attrs:{"size":"90","indeterminate":"","color":"lime"}},[_vm._v(" loading .. ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }